import { MFormStore } from "src/components/MForm/MFormStore";

export const createClassCardFormStore = () => new MFormStore();
